var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "90979F95-10F7-4A09-88AB-48513252D2F8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cotizap---Final---Internas",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cotizap-1.0.0.3-Ayuda",
    transform: "translate(-1188.000000, -75.000000)",
    fill: "#226095"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1828778-copy",
    transform: "translate(1188.000000, 75.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.79203126,6.58535156 L12.9204688,1.45675784 C13.2542188,1.12316408 13.2542188,0.58378908 12.9204688,0.25019532 C12.586875,-0.08339844 12.0475,-0.08339844 11.7139063,0.25019532 L6.5853125,5.37878908 L1.45687502,0.25019532 C1.12312502,-0.08339844 0.58390626,-0.08339844 0.2503125,0.25019532 C-0.0834375,0.58378908 -0.0834375,1.12316408 0.2503125,1.45675784 L5.37875002,6.58535156 L0.2503125,11.7139453 C-0.0834375,12.0475391 -0.0834375,12.5869141 0.2503125,12.9205078 C0.4165625,13.0869141 0.63515626,13.1705078 0.85359378,13.1705078 C1.07203126,13.1705078 1.29046878,13.0869141 1.45687502,12.9205078 L6.5853125,7.79191408 L11.7139063,12.9205078 C11.8803125,13.0869141 12.09875,13.1705078 12.3171875,13.1705078 C12.535625,13.1705078 12.7540625,13.0869141 12.9204688,12.9205078 C13.2542188,12.5869141 13.2542188,12.0475391 12.9204688,11.7139453 L7.79203126,6.58535156 Z",
    id: "Path"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.6537faeef08c819df198b04e50f01faf.svg";
export { ForwardRef as ReactComponent };